// src/pages/Service/Service Entry/ServiceEntry.jsx
import React, { useEffect, useState } from "react";
import { Row, Col, Button, Flex, Grid } from "antd";

const { useBreakpoint } = Grid;
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CreateServiceForm from "./components/CreateServiceForm";
import ServiceTable from "./components/ServiceTable";
import { createServiceEntry } from "./serviceThunk";
import { resetServiceEntry, setFormField } from "./serviceSlice";
import Swal from "sweetalert2";
import { getAccessType } from "../../../../lib/functions";

const ServiceEntry = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const screens = useBreakpoint();
  const isMobile = !screens.sm;
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("service_entry");
    access_type_set(access);
  }, []);

  const { itemCart,
    customerInfo,
    narration,
    payServiceCart,
    selectedServiceAcc,
    selectedDiscountAcc,
    selectedTaxAcc,
    selectedTransportAcc,
    footerValues,
    tag_field_id } = useSelector((s) => s.serviceEntry);
  console.log(tag_field_id, "tag_field_id");

  useEffect(() => {
    return () => {
      dispatch(resetServiceEntry());
    };
  }, [dispatch]);


  function sanitizeServiceItems(items) {
    return items.filter(
      (row) => row.item_id && Number(row.quantity) > 0
    );
  }

  function validateDuplicateServiceItems(items) {
    const seen = new Set();

    for (const row of items) {
      const key = [
        row.item_id,
        Number(row.rate || 0).toFixed(2),
        Number(row.tax_per || 0),
        Number(row.discount || 0)
      ].join("|");

      if (seen.has(key)) {
        return {
          valid: false,
          message: `Duplicate service detected: ${row.product}`,
        };
      }
      seen.add(key);
    }

    return { valid: true };
  }


  const handleSave = () => {

    const cleanedItems = sanitizeServiceItems(itemCart);

    if (cleanedItems.length === 0) {
      Swal.fire(
        "Invalid Service Entry",
        "Please add at least one service with quantity.",
        "warning"
      );
      return;
    }

    const { valid, message } =
      validateDuplicateServiceItems(cleanedItems);

    if (!valid) {
      Swal.fire("Duplicate Service Item", message, "warning");
      return;
    }


    const {
      description: narration,
      subtotal,
      total_discount,
      total_tax,
      grandTotal,
      paidAmount,
      dueAmount,
      serviceCharge,
      discountPct,
      taxPct,
    } = footerValues;

    const convertedTotal = (payServiceCart || []).reduce(
      (sum, p) => sum + parseFloat(p.tran_amount || p.amount || 0),
      0
    );
    
    const paymentDifference = Math.abs(Number(grandTotal) - convertedTotal);

    dispatch(
      setFormField({
        field: "itemCart",
        value: cleanedItems,
      })
    );

    const hasConversionRate = Number(footerValues?.conversion_rate) > 0;
    
    const maxAllowedCartTotal = hasConversionRate
      ? Number(footerValues.grandTotal) + 0.1
      : Number(footerValues.grandTotal);


    if (!customerInfo || !customerInfo.acc_id) {
      Swal.fire("Select customer!", "", "warning");
      return;
    }
    if (!itemCart || itemCart.length === 0) {
      Swal.fire("Item cart is Empty!", "", "warning");
      return;
    }
    if (narration && narration.length > 255) {
      Swal.fire("Description max size exceeded", "", "warning");
      return;
    }
    if (itemCart.length === 0) {
      Swal.fire("Item cart is empty!");
      return;
    }
    if (!selectedServiceAcc) {
      Swal.fire("Select Services Account!");
      return;
    }
    if (!selectedDiscountAcc) {
      Swal.fire("Discount Account is required!");
      return;
    }
    if (!selectedTaxAcc) {
      Swal.fire("VAT Account is required!");
      return;
    }

    if (customerInfo.institution_name && customerInfo.institution_name.length > 100) {
      Swal.fire("Institution Name size exceeded!");
      return;
    }
    if (customerInfo.address && customerInfo.address.length > 200) {
      Swal.fire("Address size exceeded!");
      return;
    }
    if (!customerInfo.contact_no || customerInfo.contact_no.length <= 0) {
      Swal.fire("Contact No is required!");
      return;
    }
    console.log(convertedTotal, paidAmount, "paidAmount12e");

    if (Number(convertedTotal) !== paidAmount) {
      Swal.fire(
        "Paid Amount & Payment Cart Amount should be same!"
      );
      return;
    }

    if (Number(convertedTotal.toFixed(2)) > Number(maxAllowedCartTotal.toFixed(2))) {      
        Swal.fire({
        title: "Payment amount exceeds total!",
        text: `Cart Total (${convertedTotal.toFixed(
          2
        )}) should not exceed Grand Total (${Number(footerValues.grandTotal).toFixed(2)})`,
        icon: "warning",
      });
      return;
    }


    Swal.fire({
      title: "Saving Service Entry...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const isEdit = !!id;
    dispatch(createServiceEntry())
      .unwrap()
      .then((res) => {
        Swal.close();
        if (!res.error) {
          Swal.fire({
            title: isEdit ? `Service Entry Updated! Do you want to view invoice?` :
              `Service Entry Created! Do you want to view invoice?`,
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Yes, view invoice",
            cancelButtonText: "No, go back",
          }).then((result) => {
            dispatch(resetServiceEntry());
            if (result.isConfirmed) {
              navigate(`/service/quick-service-voucher/${res.service_id}`);
            } else {
              navigate("/service");
              window.location.reload();
            }
          });
        } else {
          Swal.fire(res.message || "Something went wrong", "", "warning");
        }
      })
      .catch((err) => {
        Swal.close();
        Swal.fire(err || "Network ERROR", "", "error");
      });
  };

  const handleBack = () => {
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      navigate(-1);
    }
  };

  const handleReset = () => {
    dispatch(resetServiceEntry());
    Swal.fire("Form Reset", "All fields and items cleared", "info");
  };

  const ActionButtons = () => (
    <Flex justify="flex-end" wrap="wrap" gap={16} style={{ marginBottom: 16 }}>
      <Button onClick={handleBack} style={isMobile ? { flex: 1 } : undefined}>Back</Button>
      <Button onClick={handleReset} style={isMobile ? { flex: 1 } : undefined}>Reset</Button>
      {access_type == "WRITE" && <>
        <Button type="primary" style={isMobile ? { flex: 1 } : undefined} onClick={handleSave} data-testid="final-save-btn">
          Save
        </Button>
      </>}

    </Flex>
  );

  return (
    <div style={{ padding: isMobile ? 10 : 20 }}>
      <Row>
        <Col span={24}>
          <ActionButtons />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CreateServiceForm editId={id} />
        </Col>
        <Col span={24}>
          <ServiceTable />
        </Col>
      </Row>

      <Row style={{ marginTop: 24 }}>
        <Col span={24}>
          <ActionButtons />
        </Col>
      </Row>
    </div>
  );
};

export default ServiceEntry;
